'use client';

import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import type { ProductReviews } from 'src/lib/trusted-shops/product-reviews';
export function useAppExperienceReviews(publicId) {
  const $ = _c(2);
  let t0;
  if ($[0] !== publicId) {
    t0 = {
      queryKey: ["experience-reviews", publicId],
      queryFn: async () => {
        const response = await fetch(`/api/trusted/experiences/${publicId}/`);
        if (!response.ok) {
          throw new Error("Product reviews unavailable");
        }
        return response.json();
      },
      staleTime: 3600000,
      retry: false,
      refetchOnWindowFocus: false
    };
    $[0] = publicId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useQuery(t0);
}